module.exports = __webpack_public_path__ + "img/trawenagh-big.32d56301.jpg";